import Main from './Main';

export default Main;
export * from './Main';
